var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tables.length > 0)?_c('CrudDatabase',{attrs:{"tables":_vm.tables,"currentCompany":_vm.getUserCompany}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }